import React, { useState, useEffect, memo } from 'react';

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 65%, 60%)`;
  return color;
};

const getInitials = (text) =>
  (text || '')
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

// Avatar — image with a clean initials fallback. Previously the fallback was
// `e.target.src = ''` which left a broken-image silhouette (the chat list
// looked awful when many users had no profile picture). Now we track the
// error in state and render a coloured initials block instead.
const Avatar = ({ src, alt = '', size = 32, fallbackText = '', className = '', initialsSize = null }) => {
  const [errored, setErrored] = useState(false);
  // Reset error state if the src changes (different user selected etc.)
  useEffect(() => { setErrored(false); }, [src]);

  const seed = fallbackText || alt || '?';
  const initials = getInitials(fallbackText) || '?';

  if (!src || errored) {
    return (
      <div
        className={`flex items-center justify-center rounded-full text-white font-medium select-none ${className}`}
        style={{
          backgroundColor: stringToColor(seed),
          width: size,
          height: size,
          fontSize: initialsSize || Math.max(10, Math.floor(size * 0.4)),
        }}
        aria-label={alt}
      >
        {initials}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={`rounded-full object-cover ${className}`}
      onError={() => setErrored(true)}
      style={{ width: size, height: size }}
    />
  );
};

export default memo(Avatar);
